<!--dialogo para mostrar el detalle de la ubicacion...-->
<!--<p-dialog  [modal]="true" [baseZIndex]="10000" [(visible)]="showDetails" [style]="{width: '50vw'}"
           [contentStyle]="{padding: '2em', textAlign: 'center'}">
</p-dialog>-->
<!--<div *ngIf="selectedProvider" class="p-col-12 p-md-12" style="padding: '2em'; textAlign: 'center'">
  <h2>{{selectedProvider["name"]}}</h2>
  <h4>Direccion: {{selectedProvider["fullAddress"]}}</h4>
  <div *ngIf="contactProvider ;  then contacts"></div>
</div>-->
<div class="ui-g-12 ui-fluid">
  <div class="p-grid" *ngIf="infoProviders.length>0" >
    <p-dataView #dvInfo  [value]="infoProviders" [paginator]="true" [rows]="30" paginatorPosition="bottom" filterBy="fullAddress" sortOrder="priority" layout="grid" class="ui-g-12">
      <p-header>
        <div style="position: relative; margin: 1% 0;">
          <input type="search" pInputText placeholder="Búsqueda por dirección o nombre" (input)="dvInfo.filter($event.target.value, 'contains')">
          <i style="float: right;     margin: 4px; top: 10px; right: 13px; position: absolute;" class="pi pi-search search-icon" ></i>
        </div>
      </p-header>
      <ng-template let-info pTemplate="gridItem">
        <div class="ui-g-12 ui-md-4" style="border: 0.05px solid #91a2bd; border-radius: 1em; margin-bottom: 2%;">
          <div class="provider-details">
            <div class="ui-g-12">
              <div class="ui-g-12 ui-md-12 ui-sm-10">
                <div class="ui-g-12" >
                  <div class="ui-g-12"><b>{{info.name}}</b></div>
                  <div class="ui-g-12">{{info.fullAddress}}</div>
                  <div class="ui-g-12">
                    <div class="ui-g-6">
                      <button pButton type="button" class="ui-button-primary btn-dv" id="{{info.idLocation}}m"  label="contacto" icon="pi pi-angle-right" (click)="showContact($event, info, false, info.idLocation)"></button>
                    </div>
                    <div class="ui-g-6">
                      <button pButton type="button"  class="ui-button-primary btn-dv" id="{{info.idLocation}}c"  label="Horarios" icon="pi pi-angle-right" (click)="showSchedule($event, info, false, info.idLocation)"></button>
                    </div>
                  </div>
                </div>
                <div class="ui-g-12 ui-md-12 ui-sm-12">
                  <div *ngFor="let contact of contactProvider;">
                    <h4 *ngIf="showDetailsContact && info.idLocation == contact.idLocation.idLocation" style="color: #073c8f;">{{contact["idTypeContact"]["strDescription"]}}: {{contact["strDescription"]}}</h4>
                  </div>
                </div>
                <div class="ui-g-12 ui-md-12 ui-sm-12">
                  <div *ngFor="let schedule of scheduleProvider;">
                    <h4 *ngIf="showDetailsSchedule && info.idLocation == schedule.idLocation.idLocation"  style="color: #073c8f;">Horario: {{schedule["strDescription"]}}</h4>
                  </div>
                </div>


              </div>
            </div>
            <!--<div>    comente esta parte porque mostraba el icono y la palabra proveedor en cada ubicacion.
              <div>
                <img style="width: 5%;" src="../../assets/images/telemedicina/paso1.png">
              </div>
              <div class="p-col-12">
                <h2 style="font-weight: 900; font-size: 28px; margin-bottom: 2%;">Proveedor</h2>
              </div>
            </div>-->
          </div>
        </div>
      </ng-template>
    </p-dataView>
  </div>

  <p-overlayPanel #op [showCloseIcon]="true">
    <ng-template>

    </ng-template>
  </p-overlayPanel>
</div>

<!--<ng-template #contacts>

</ng-template>-->
